// Publications that should include the Adnami ad script in the header

export const adnamiAdScriptPublications: string[] = [
  'abergavennychronicle.com',
  'altonherald.com',
  'bordonherald.com',
  'brecon-radnor.co.uk',
  'bude-today.co.uk',
  'cambrian-news.co.uk',
  'chepstowbeacon.co.uk',
  'cornish-times.co.uk',
  'creditoncourier.co.uk',
  'dartmouth-today.co.uk',
  'dawlish-today.co.uk',
  'farnhamherald.com',
  'haslemereherald.com',
  'holsworthy-today.co.uk',
  'iomtoday.co.im',
  'ivybridge-today.co.uk',
  'kingsbridge-today.co.uk',
  'liphookherald.com',
  'middevonadvertiser.co.uk',
  'mnrjournal.co.uk',
  'monmouthshirebeacon.co.uk',
  'narberth-and-whitland-today.co.uk',
  'okehampton-today.co.uk',
  'pembroke-today.co.uk',
  'petersfieldpost.co.uk',
  'rossgazette.com',
  'southhams-today.co.uk',
  'tamarvalleytimes.co.uk',
  'tavistock-today.co.uk',
  'teignmouth-today.co.uk',
  'tenby-today.co.uk',
  'theforestreview.co.uk',
  'thepost.uk.com',
  'totnes-today.co.uk',
  'voicenewspapers.co.uk',
  'wellington-today.co.uk',
  'wokingnewsandmail.co.uk',
  'wsfp.co.uk',
]
